import * as apicall from "../components/Apicall";

// Crew skills are backend metadata (sql/ezp_skills.sql): a fixed set, worded per
// industry, that a vendor cannot add to. Everything the screens show about a
// skill - its label, and whether there is a choice at all - comes from here, never
// from an inline industry ternary.

// data.data: [{ skill_key, name, label, is_default }], default first. Before the
// skills migration has run the API answers with just PROFESSIONAL, so no screen
// shows a selector.
export const getSkills = () => apicall.get("skills");

export const DEFAULT_SKILL = "PROFESSIONAL";
export const DRIVER_SKILL = "DRIVER";

// The wording for a skill key, falling back to the key's own name.
export const skillLabel = (skills, key) => {
  const hit = (skills || []).find((s) => s.skill_key === key);
  return hit ? hit.label : key === DRIVER_SKILL ? "Driver" : "";
};

// A selector is only worth showing when there is something to choose between.
export const offersChoice = (skills) => (skills || []).length > 1;

// 'Ali (Driver)' - a person with the skill's wording, for pickers.
export const nameWithSkill = (name, skillKey, skills) => {
  const label = skillLabel(skills, skillKey);
  return label && offersChoice(skills) ? `${name} (${label})` : name;
};
